// React things
import React, { useEffect, useState, useRef } from "react";

// Styles
import style from "./TipProvider.module.css";

// Components
import MessageTip from "../MessageTip/MessageTip";

export default function TipProvider(props) {
	const [hide, setHide] = useState(true);
	const containerRef = useRef(null);
	let timeToHide = null;

	useEffect(() => {
		return () => {
			clearTimeout(timeToHide);
		};
	}, []);

	useEffect(() => {
		const handleClickOutside = event => {
			if (
				containerRef.current &&
				!containerRef.current.contains(event.target)
			) {
				setHide(true);
				clearTimeout(timeToHide);
			}
		};

		if (!hide) {
			props.setAnimation(true);
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			props.setAnimation(false);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [hide]);

	const handleToggle = () => {
		clearTimeout(timeToHide);
		setHide(!hide);

		if (hide) {
			timeToHide = setTimeout(() => {
				setHide(true);
			}, 5000);
		}
	};

	return (
		<div className={style["container"]} ref={containerRef}>
			<div onClick={handleToggle} className={style["eventable-area"]}>
				{props.children.filter(
					element => element.type.displayedName == "EventableArea"
				)}
			</div>
			<div className={`${style["message-tip"]} ${hide && style["hide"]}`}>
				{props.children.find(
					element => element.type.displayedName === "MessageTip"
				)}
			</div>
		</div>
	);
}
